import React, { useState } from 'react';
import styled from 'styled-components';

import Button from 'components/core/Button';
import MediaPickerModal from 'modals/MediaPickerModal';

import { TMediaType } from 'api/media';
import { openFilePicker } from 'helpers/image';

const StyledRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s}px;

  & > * {
    flex: 1;
    min-width: 0;
  }
`;

type TMediaSourceProps = {
  mediaTypes: TMediaType[];
  disabled?: boolean;
  onPick: (url: string, mediaType: TMediaType, mediaId?: string) => void;
};

const MediaSource = ({ mediaTypes, disabled, onPick }: TMediaSourceProps) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const only = mediaTypes.length === 1 ? mediaTypes[0] : undefined;
  const acceptFor = (): string => {
    if (only === 'VIDEO') {
      return 'video/*';
    }
    if (only === 'IMAGE') {
      return 'image/*';
    }
    return 'image/*,video/*';
  };
  const accept = acceptFor();

  const handleUpload = () =>
    openFilePicker(accept, (dataUrl, file) =>
      onPick(dataUrl, file.type.startsWith('video/') ? 'VIDEO' : 'IMAGE')
    );

  return (
    <>
      <StyledRow>
        <Button
          variant="secondary"
          size="sm"
          disabled={disabled}
          onClick={() => setIsPickerOpen(true)}>
          Choose from Assets
        </Button>
        <Button variant="secondary" size="sm" disabled={disabled} onClick={handleUpload}>
          Upload
        </Button>
      </StyledRow>

      <MediaPickerModal
        isOpen={isPickerOpen}
        mediaTypes={mediaTypes}
        onClose={() => setIsPickerOpen(false)}
        onSelect={onPick}
      />
    </>
  );
};

export default MediaSource;
